// Bridges the website to the native Android call-tracking plugin (Capacitor).
// Safe no-op when running in a normal browser (not inside the Android app).

export async function syncTokenToNativeApp(token) {
  try {
    const { Capacitor } = await import('@capacitor/core');
    if (!Capacitor.isNativePlatform()) return;

    const { registerPlugin } = await import('@capacitor/core');
    const CallTracking = registerPlugin('CallTracking');

    await CallTracking.saveAuthToken({ token });
    const result = await CallTracking.requestCallPermissions();
    console.log('[CallTracking] permission result:', result);
  } catch (e) {
    console.log('[CallTracking] not available (probably running in browser):', e.message);
  }
}
